import WorkflowCenter from './workflow-center';
export default {
    namespaced: true,
    modules: {
        WorkflowCenter
    }
};
